module.exports = __webpack_public_path__ + "img/damir.68dec93a.jpg";